import { render } from "./UserPassForm.component.vue?vue&type=template&id=4779d9d4&scoped=true&ts=true"
import script from "./UserPassForm.component.vue?vue&type=script&lang=ts"
export * from "./UserPassForm.component.vue?vue&type=script&lang=ts"

import "./UserPassForm.component.vue?vue&type=style&index=0&id=4779d9d4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4779d9d4"]])

export default __exports__